import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'LineItem',
    column_type: 'id',
    label_key_path: 'lineItem.id',
  },
  created_at: {
    model_name: 'LineItem',
    column_type: 'datetime',
    label_key_path: 'lineItem.createdAt',
  },
  updated_at: {
    model_name: 'LineItem',
    column_type: 'datetime',
    label_key_path: 'lineItem.updatedAt',
  },
  color_option_value: {
    model_name: 'LineItem',
    column_type: 'belongs_to',
    label_key_path: 'lineItem.colorOptionValue',
    extra: {
      association_name: 'color_option_value',
      model_name: 'OptionValue',
      foreign_key: 'color_option_value_id',
      display_column: 'name',
    },
  },
  color_option_value_id: {
    model_name: 'LineItem',
    column_type: 'belongs_to',
    label_key_path: 'lineItem.colorOptionValue',
    extra: {
      association_name: 'color_option_value',
      model_name: 'OptionValue',
      foreign_key: 'color_option_value_id',
      display_column: 'name',
    },
  },
  complete_quantity: {
    model_name: 'LineItem',
    column_type: 'integer',
    label_key_path: 'lineItem.completeQuantity',
  },
  cutting_quantity: {
    model_name: 'LineItem',
    column_type: 'integer',
    label_key_path: 'lineItem.cuttingQuantity',
  },
  order: {
    model_name: 'LineItem',
    column_type: 'belongs_to',
    label_key_path: 'lineItem.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  order_id: {
    model_name: 'LineItem',
    column_type: 'belongs_to',
    label_key_path: 'lineItem.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  quantity: {
    model_name: 'LineItem',
    column_type: 'integer',
    label_key_path: 'lineItem.quantity',
  },
  size_option_value: {
    model_name: 'LineItem',
    column_type: 'belongs_to',
    label_key_path: 'lineItem.sizeOptionValue',
    extra: {
      association_name: 'size_option_value',
      model_name: 'OptionValue',
      foreign_key: 'size_option_value_id',
      display_column: 'name',
    },
  },
  size_option_value_id: {
    model_name: 'LineItem',
    column_type: 'belongs_to',
    label_key_path: 'lineItem.sizeOptionValue',
    extra: {
      association_name: 'size_option_value',
      model_name: 'OptionValue',
      foreign_key: 'size_option_value_id',
      display_column: 'name',
    },
  },
  sku: {
    model_name: 'LineItem',
    column_type: 'string',
    label_key_path: 'lineItem.sku',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
